module.exports = __webpack_public_path__ + "img/engagement.10e902c4.png";